import { useEffect, useState, useMemo } from "react";
import { createCable } from "../utils/actionCable";

export default function useNotificationsCable(userId, token) {
  const [notifications, setNotifications] = useState([]);

  const cable = useMemo(() => {
    if (!token) return null;

    return createCable(token);
  }, [token]);

  useEffect(() => {
    if (!userId || !cable) return;

    const subscription = cable.subscriptions.create(
      { channel: "NotificationsChannel", user_id: userId },
      {
        connected() {
          console.log("WebSocket connected to NotificationsChannel");
        },
        received(data) {
          if (!data) return;
          setNotifications((prev) => [data, ...prev]);
        },
        disconnected() {
          console.log("WebSocket disconnected from NotificationsChannel");
        },
      }
    );

    if (!subscription || !subscription.received) {
      console.error("Subscription not created!", subscription);
    }

    return () => {
      if (subscription) {
        subscription.unsubscribe();   // correct
        // cable.disconnect();        // DO NOT CALL HERE
      }
    };
  }, [userId, cable]);                // FIXED: cable instead of token

  return notifications;
}
